import axios from "axios";
import { apiURL } from "../config/default";
import { PRODUCT_FAIL, PRODUCT_SUCCESS } from "./types";
import setAuthHeader from "../utils/setAuthHeader";
import { addRecentProducts, getRecentProducts } from "../utils/storage";

export const retreiveBySlug = (slug, categoryIdentifier) => async (
  dispatch
) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(
      `${apiURL}products/${slug}?CatagorySlug=${categoryIdentifier}`,
      _config
    );
    // var product = res.data["product"][0];
    // const object = {
    //   id: product["_id"],
    //   name: product["title"],
    //   slug: product["slug"],
    //   image: product["images"][0],
    //   price: product["price"],
    //   reviews: product["reviews"],
    //   reviewCount: product["reviewCount"],
    //   saleDiscount: product["saleDiscount"],
    //   enableSale: product["enableSale"],
    // };
    // console.log(product);
    // let rows = [];
    // var arr = getRecentProducts();
    // if (arr) {
    //   if (arr.length > 19) {
    //     arr.splice(0, 1);
    //   }
    //   arr.forEach((item) => {
    //     if (item["id"] !== object["id"]) {
    //       rows.push(item);
    //     }
    //   });
    // }

    // rows.push(object);
    // console.log(rows);

    // addRecentProducts(rows, () => {});

    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: PRODUCT_FAIL,
    });
  }
};
export const sellerProducts = (brand) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  const _config = {
    hearders: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(`${apiURL}seller-products/${brand}`, _config);
    return res.data;
  } catch (error) {
    console.log(error);
    dispatch({ type: PRODUCT_FAIL });
  }
};
export const bulkProducts = (data) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const _data = JSON.stringify(data);

  try {
    const res = await axios.post(`${apiURL}bulk-product`, data, _config);
    return res;
  } catch (err) {
    const errors = err.response.data.error;
    if (errors) {
      errors.forEach((error) => {
        dispatch(
          alert(error.msg, "danger", {
            marginTop: "3em",
            marginBottom: "3em",
            width: "25%",
            marginBottom: "1%",
          })
        );
      });
    }
  }
};
export const discountProducts = (e) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(`${apiURL}discount-products`, _config);
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "3em" }));
      });
    }
  }
};
export const getProductsByCategoryId = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(
      `${apiURL}get-products-by-category-id/${id}`,
      _config
    );

    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: PRODUCT_FAIL,
    });
  }
};
export const randomProducts = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(`${apiURL}get-random-products`, _config);

    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: PRODUCT_FAIL,
    });
  }
};

export const retreiveByQuickViewId = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(`${apiURL}product-images/${id}`, _config);
    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: PRODUCT_FAIL,
    });
  }
};
